import React from "react";
import './index.less';

const ContentBox = (props: any) => {
    const {children} = props;
    
    return (
        <div className="content-box-wrapper">
            {children}
        </div>
    )
}

export default ContentBox;